import mansoqConfig from "@mansoqConfig";
import { useEffect } from "react";

interface Props {
  disabled?: boolean;
}

export default function Sentry({ disabled }: Props) {
  useEffect(() => {
    if (disabled || !mansoqConfig.sentry.dsn) return;
    if (!mansoqConfig.sentry.environment) {
      console.error(
        "Sentry is not configured correctly. Please check your environment variables.",
      );
      return;
    }

    import("@sentry/browser").then((Sentry) => {
      Sentry.init(mansoqConfig.sentry);
    });
  }, [disabled]);

  return null;
}
